import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/live';
import {defaultImage} from '../../../../assets/symbols/images/defaultImage';
import CheckMark from '../../../../assets/icons/checkMark';
import SoldOut from '../../../../assets/icons/SoldOut';
import {TEticketSubscriptionEvent} from '../../../../redux/eTicket/eTicket.type';
import {getDateFormat, getHourMinutes} from '../../../../library/dates';
import {openUrl} from '../../TransactionCard/transactionCardUtils';
import {getSubscriptionEventState, subscriptionEventStateConfig} from '../memberTicket.utils';
import * as css from './MemberRedeemSheet.css';

interface MemberEventRowProps {
    event: TEticketSubscriptionEvent;
}

/* A row of one series event — the button leads to the sale page of that show, where the member's
   own subscriptions are offered as payment once they are logged in. The address is built by the
   API from the event's domain and name; with no address there is nowhere to send them. */
function MemberEventRow({event}: MemberEventRowProps) {
    const {t} = useTranslation('eTicket');
    const state = getSubscriptionEventState(event);
    const {textKey, available} = subscriptionEventStateConfig[state];
    const dateParts = event.timeStart
        ? [getHourMinutes(event.timeStart), getDateFormat(event.timeStart, 'DD.MM.YYYY')]
        : [];

    return (
        <css.row data-cy={`member-event-row-${event.eid}`}>
            <css.poster>
                <img src={event.image || defaultImage} alt="" loading="lazy" decoding="async" />
                {event.redeemed && <css.redeemed>{t('eventRedeemed')}</css.redeemed>}
            </css.poster>
            <css.main>
                <css.top>
                    {!!dateParts.length && <css.datetime>{dateParts.join(' | ')}</css.datetime>}
                    <css.title>{event.title}</css.title>
                </css.top>
                <css.bottom>
                    <css.status $available={available}>
                        {available && (
                            <css.checkMarkCircle>
                                <CheckMark color="currentColor" width={10} height={8} />
                            </css.checkMarkCircle>
                        )}
                        {state === 'soldOut' && (
                            <css.soldOutCircle>
                                <SoldOut width={13} height={9} />
                            </css.soldOutCircle>
                        )}
                        {t(textKey)}
                    </css.status>
                    <Button
                        variant="brand"
                        size="chip"
                        disabled={!available || !event.url}
                        onClick={() => openUrl(event.url)}
                        data-cy={`member-event-buy-${event.eid}`}>
                        {t('goToEventTickets')}
                    </Button>
                </css.bottom>
            </css.main>
        </css.row>
    );
}

export default MemberEventRow;
